import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchFloorplanPlacement } from '../services/patchFloorplanPlacement.service';

export const updateFloorplanPlacement = createAsyncThunk(
  'floorplans/updateFloorplanPlacement',
  async ({ projectId, placementId, x, y }, { rejectWithValue }) => {
    try {
      const placement = await patchFloorplanPlacement(projectId, placementId, {
        x,
        y,
      });
      return placement;
    } catch (err) {
      return rejectWithValue({ message: err.message, placementId });
    }
  }
);
